// extracted by mini-css-extract-plugin
module.exports = {"root":"standalone-services-page_root__jeJil"};